<template>
    <div class="base-create-header">
      <h1>
        <span class="circle-step">{{addLearnerStep}}</span>
        <span>
          {{ title }}
        </span>
        <slot name="tooltip"></slot>
      </h1>
    </div>
</template>

<script>
  export default {
    props: {
      addLearnerStep: {
        default: 3
      },
      title: {
          type: String,
          default: ''
      },
      organizationType: {
       type: String,
       default: null
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
